/* VELOURÉA — full-screen reel viewer for <v-reels data-viewer> (product videos, customer videos). */
(() => {
  if (window.vReelViewer) return;
  window.vReelViewer = true;

  const ICONS = {
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    up: '<path d="m6 15 6-6 6 6"/>',
    down: '<path d="m6 9 6 6 6-6"/>',
    mute: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="m16 9.5 5 5M21 9.5l-5 5"/>',
    volume: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
    share: '<circle cx="6" cy="12" r="2.5"/><circle cx="17.5" cy="5.5" r="2.5"/><circle cx="17.5" cy="18.5" r="2.5"/><path d="m8.2 10.8 7.1-4M8.2 13.2l7.1 4"/>',
    instagram: '<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r=".6" fill="currentColor"/>',
    tiktok: '<path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.6"/>'
  };
  const svg = (n) => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${ICONS[n]}</svg>`;
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  let dlg, stage, host, items = [], idx = 0, muted = false, touchY = null, toastT;

  function itemsFor(h) {
    return [...h.querySelectorAll('[data-reel-open]')].map((btn) => {
      const d = btn.dataset;
      if (d.src || d.full) return { btn, type: 'video', src: d.full || d.src, poster: d.poster || '' };
      const media = btn.closest('.reel__media') || btn;
      const v = media.querySelector('video');
      if (v) {
        const s = v.querySelector('source');
        return { btn, type: 'video', src: v.dataset.full || (s && (s.dataset.src || s.src)), poster: v.poster };
      }
      const img = media.querySelector('img');
      if (!img) return null;
      const set = (img.getAttribute('srcset') || '').split(',').map((x) => x.trim().split(/\s+/)[0]).filter(Boolean);
      return { btn, type: 'img', src: set[set.length - 1] || img.currentSrc || img.src };
    }).filter((it) => it && it.src);
  }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'rv';
    dlg.innerHTML = `
      <div class="rv__stage" data-rv-stage>
        <div class="rv__top">
          <div class="rv__who" data-rv-who></div>
          <span class="rv__count" data-rv-count dir="ltr"></span>
          <button type="button" class="rv__btn" data-rv="close">${svg('close')}</button>
        </div>
        <div class="rv__bottom">
          <div class="rv__side">
            <button type="button" class="rv__btn" data-rv="sound" aria-pressed="false">${svg('volume')}</button>
            <button type="button" class="rv__btn" data-rv="share">${svg('share')}</button>
          </div>
          <div class="rv__thumbs" data-rv-thumbs hidden></div>
          <div class="rv__product" data-rv-product></div>
        </div>
      </div>
      <div class="rv__nav" data-rv-nav>
        <button type="button" class="rv__btn" data-rv="prev">${svg('up')}</button>
        <button type="button" class="rv__btn" data-rv="next">${svg('down')}</button>
      </div>`;
    document.body.appendChild(dlg);
    stage = dlg.querySelector('[data-rv-stage]');

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) return close();
      const b = e.target.closest('[data-rv]');
      if (b) {
        const a = b.dataset.rv;
        if (a === 'close') close();
        else if (a === 'prev') go(idx - 1);
        else if (a === 'next') go(idx + 1);
        else if (a === 'sound') setMuted(!muted);
        else if (a === 'share') share();
        return;
      }
      if (e.target.closest('button[data-rv-cta]')) return toProduct();
      const v = e.target.closest('video.rv__media');
      if (v) v.paused ? v.play().catch(() => {}) : v.pause();
    });
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); go(idx - 1); }
    });
    stage.addEventListener('touchstart', (e) => { touchY = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (touchY == null) return;
      const dy = e.changedTouches[0].clientY - touchY;
      touchY = null;
      if (Math.abs(dy) > 50) go(idx + (dy < 0 ? 1 : -1));
    }, { passive: true });
  }

  function labels() {
    const d = host.dataset;
    dlg.setAttribute('aria-label', d.lDialog || '');
    const set = (a, l) => dlg.querySelector(`[data-rv="${a}"]`).setAttribute('aria-label', l || '');
    set('close', d.lClose); set('prev', d.lPrev); set('next', d.lNext); set('sound', d.lSound); set('share', d.lShare);
    dlg.querySelector('[data-rv-nav]').hidden = items.length < 2;
  }

  /* Per-video details: the clicked button's data-* wins over the section's defaults. */
  function details(it) {
    const h = host.dataset, d = it.btn.dataset;
    return {
      title: d.pTitle || h.title, price: d.pPrice || h.price, image: d.pImage || h.image,
      url: d.pUrl || '', images: (d.pImages || '').split('|').filter(Boolean),
      name: d.cName || '', ig: d.cIg || '', igF: d.cIgF || '', tt: d.cTt || '', ttF: d.cTtF || ''
    };
  }

  function renderInfo(it) {
    const h = host.dataset, m = details(it);
    const who = dlg.querySelector('[data-rv-who]');
    const social = (net, handle, followers, url, label) => handle
      ? `<a class="rv__social" href="${esc(url)}" target="_blank" rel="noopener" aria-label="${esc(label)} @${esc(handle)}">${svg(net)}${followers ? `<span>${esc(followers)} ${esc(h.lFollowers)}</span>` : `<span>@${esc(handle)}</span>`}</a>`
      : '';
    who.innerHTML = (m.name ? `<strong>${esc(m.name)}</strong>` : '')
      + social('instagram', m.ig, m.igF, `https://www.instagram.com/${encodeURIComponent(m.ig)}/`, 'Instagram')
      + social('tiktok', m.tt, m.ttF, `https://www.tiktok.com/@${encodeURIComponent(m.tt)}`, 'TikTok');

    const thumbs = dlg.querySelector('[data-rv-thumbs]');
    thumbs.innerHTML = m.images.slice(0, 4).map((src) => `<a href="${esc(m.url)}" tabindex="-1"><img src="${esc(src)}" alt="" width="64" height="80" loading="lazy"></a>`).join('');
    thumbs.hidden = !m.images.length || !m.url;

    const p = dlg.querySelector('[data-rv-product]');
    p.hidden = !m.title;
    const cta = m.url
      ? `<a class="rv__cta" href="${esc(m.url)}" data-rv-cta>${esc(h.ctaLink || h.cta)}</a>`
      : `<button type="button" class="rv__cta" data-rv-cta>${esc(h.cta)}</button>`;
    p.innerHTML = `${m.image ? `<img src="${esc(m.image)}" alt="" width="44" height="55">` : '<span></span>'}
      <p><strong>${esc(m.title)}</strong>${esc(m.price)}</p>${cta}`;
  }

  function setMuted(m) {
    muted = m;
    const b = dlg.querySelector('[data-rv="sound"]');
    b.setAttribute('aria-pressed', String(!m));
    b.innerHTML = svg(m ? 'mute' : 'volume');
    const v = stage.querySelector('video.rv__media');
    if (v) v.muted = m;
  }

  function go(i) {
    if (!items.length) return;
    idx = (i + items.length) % items.length;
    const it = items[idx];
    const old = stage.querySelector('.rv__media');
    if (old) { if (old.tagName === 'VIDEO') { old.pause(); old.removeAttribute('src'); old.load(); } old.remove(); }
    let el;
    if (it.type === 'video') {
      el = document.createElement('video');
      el.playsInline = true; el.loop = true; el.muted = muted; el.preload = 'auto';
      if (it.poster) el.poster = it.poster;
      el.src = it.src;
      el.setAttribute('aria-label', it.btn.getAttribute('aria-label') || host.dataset.title || '');
    } else {
      el = document.createElement('img');
      el.src = it.src; el.alt = '';
    }
    el.className = 'rv__media';
    stage.prepend(el);
    renderInfo(it);
    if (it.type === 'video') {
      el.play().catch(() => { setMuted(true); el.play().catch(() => {}); });
    }
    dlg.querySelector('[data-rv-count]').textContent = items.length > 1 ? `${idx + 1} / ${items.length}` : '';
  }

  function open(h, btn) {
    host = h;
    items = itemsFor(h);
    const start = Math.max(0, items.findIndex((it) => it.btn === btn));
    if (!dlg) build();
    labels();
    h.querySelectorAll('video[data-reel]').forEach((v) => v.pause());
    document.documentElement.style.overflow = 'hidden';
    dlg.showModal();
    setMuted(false);
    go(start);
    dlg.querySelector('[data-rv="close"]').focus();
  }

  function cleanup() {
    const v = stage.querySelector('video.rv__media');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    document.documentElement.style.overflow = '';
    if (host && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      host.querySelectorAll('video[data-reel]').forEach((x) => {
        const r = x.getBoundingClientRect();
        if (r.bottom > 0 && r.top < innerHeight && x.currentSrc) x.play().catch(() => {});
      });
    }
  }

  function close() { if (dlg && dlg.open) dlg.close(); }

  function toProduct() {
    close();
    const f = document.querySelector('.pdp product-form') || document.querySelector('product-form');
    if (f) {
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = f.querySelector('input[type="radio"]');
      if (first) first.focus({ preventScroll: true });
    }
  }

  async function share() {
    const url = location.href.split('#')[0];
    if (navigator.share) {
      try { await navigator.share({ title: host.dataset.title || document.title, url }); } catch (e) { /* cancelled */ }
      return;
    }
    try { await navigator.clipboard.writeText(url); } catch (e) { return; }
    let t = stage.querySelector('.rv__toast');
    if (!t) { t = document.createElement('div'); t.className = 'rv__toast'; t.setAttribute('role', 'status'); stage.appendChild(t); }
    t.textContent = host.dataset.lCopied || '';
    t.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(() => { t.hidden = true; }, 1800);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-reel-open]');
    if (!btn) return;
    const h = btn.closest('[data-viewer]');
    if (!h) return;
    e.preventDefault();
    open(h, btn);
  });
})();
